import { useState, useEffect, useRef } from 'react';

const useOnScrollPagination = (ref: any, threshold?: number) => {
  const [isIntersecting, setIntersecting] = useState(false);
  const options = {
    rootMargin: '100px',
    threshold: threshold || 1
  }

  const observer = new IntersectionObserver((entires) => {
    entires.forEach((entry) => setIntersecting(entry.isIntersecting))
  }, options)

  useEffect(() => {
    if (ref.current) {
      const container = ref.current.firstChild;
      const lastChildFromContainer = container.lastChild;
      observer.observe(lastChildFromContainer);
    }
    return () => { observer.disconnect() }
  }, [ref, options])

  return isIntersecting
}

const Container = ({ 
  children,
  onLastElementVisible,
}: {
  children: React.ReactNode,
  onLastElementVisible: () => void
}) => {
  const ref = useRef<any>();
  const isVisible = useOnScrollPagination(ref, 0.1);

  useEffect(() => {
    if (isVisible) {
      onLastElementVisible();
    }
  }, [isVisible])

  return (
    <div ref={ref} className="pagination-container">{children}</div>
  )
}

export { Container }
